/** Onboarding / offboarding tasks and asset texts (English). */
export const lifecycle = {
  kind: {
    onboarding: "Onboarding",
    offboarding: "Offboarding",
  },
  assigneeKind: {
    hr: "HR",
    manager: "Manager",
    employee: "The employee",
    it: "IT / system admin",
    finance: "Finance",
    specific: "A specific person",
  },
  pool: {
    hr: "HR team",
    manager_missing: "HR team (no manager assigned)",
    it: "IT / system admin",
    finance: "Finance team",
  },
  category: {
    access: "Access",
    equipment: "Equipment",
    document: "Document",
    payroll: "Payroll",
    orientation: "Orientation",
    other: "Other",
  },
  taskStatus: {
    open: "Open",
    done: "Done",
    skipped: "Skipped",
  },
  checklistStatus: {
    open: "In progress",
    completed: "Completed",
    cancelled: "Cancelled",
  },
  task: {
    returnAsset: "Collect returned asset: {asset}",
    returnAssetDescription: "Collect the asset tagged {tag} and record the return. This task completes itself once the return is recorded.",
    closeAccess: "Close system and email access",
    closeAccessDescription: "At the end of the last working day, close all accounts and access cards.",
  },
  auto: {
    documentAccepted: "Completed automatically when the document was accepted.",
    assetReturned: "Completed automatically when the asset return was recorded.",
  },
  notify: {
    manyTasks: "{first} and {count} more tasks",
    noDue: "not set",
  },
  reason: {
    resignation: "Resignation",
    employer_termination: "Termination by employer",
    mutual_agreement: "Mutual agreement",
    retirement: "Retirement",
    contract_end: "End of fixed-term contract",
    other: "Other",
  },
  asset: {
    category: {
      computer: "Computer",
      phone: "Phone",
      tablet: "Tablet",
      monitor: "Monitor",
      peripheral: "Peripheral",
      access_card: "Access card",
      vehicle: "Vehicle",
      furniture: "Furniture",
      other: "Other",
    },
    status: {
      in_stock: "In stock",
      assigned: "Assigned",
      retired: "Retired",
      lost: "Lost",
    },
    condition: {
      good: "Good",
      damaged: "Damaged",
      lost: "Lost / not returned",
    },
  },
  errors: {
    checklist_exists: "This employee already has an open {kind} checklist. Use it or cancel it first.",
    use_offboarding: "Offboarding checklists are created by starting offboarding from the employee page.",
    employee_terminated: "This employee has already left; a new checklist can't be started.",
    template_kind_mismatch: "The selected template is for a different process. Choose a template of the right type.",
    task_closed_list: "This task's checklist is closed. Ask HR to start a new one if needed.",
    task_not_open: "This task is already closed. Reopen it first to change it.",
    task_already_open: "This task is already open.",
    record_asset_return: "This task completes itself once the asset return is recorded. Record the return from the assets screen.",
    asset_already_returned: "The return of this asset is already recorded; the task can't be reopened.",
    asset_already_assigned: "This asset is currently with {name}. Record its return first.",
    asset_not_available: "This asset can't be assigned because it is “{status}”. Set it to “In stock” first.",
    asset_assigned: "This can't be done while the asset is assigned. Record its return first.",
    asset_return_before_assign: "The return date can't be before the assignment date ({date}).",
    already_offboarding: "Offboarding has already been started for this employee.",
    not_offboarding: "There is no offboarding in progress for this employee.",
    last_day_before_start: "The last working day can't be before the start date ({date}).",
    before_last_working_day: "Offboarding can't be closed before the last working day ({date}). Try again on or after that day.",
    offboarding_incomplete: "Before closing, complete or skip the open tasks and record asset returns: {tasks} open tasks, {assets} unreturned assets.",
    no_balance: "There is no leave balance to pay out.",
    payout_exceeds_balance: "At most the remaining balance ({balance}) can be paid out.",
    no_annual_type: "No annual leave type was found. Choose a leave type and try again.",
    self_complete: "You can't close your own offboarding; another HR user must do it.",
    last_admin: "The leaver is the company's last system admin. Give the system admin role to someone else first.",
    open_tasks: "{count} open tasks; complete or skip them.",
    unreturned_assets: "{count} asset returns not recorded.",
  },
  payoutNote: "Unused leave paid out on leaving",
};
